import React from "react";

export default function ValentineFrame5({ frameTextToggle, children }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 2000 2000"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>
            {".cls5-1{fill:#0e141f}.cls5-2{fill:#e98ead}.cls5-3{fill:#3a4f7a}"}
          </style>
        </defs>
        <g
          id="\u0421\u043B\u043E\u0439_3"
          data-name="\u0421\u043B\u043E\u0439 3"
        >
          <path
            className="cls5-1"
            transform="rotate(-166.35 1392.035 1731.652)"
            d="M1384.96 1686.52h14.3v90.16h-14.3z"
          />
          <path
            className="cls5-2"
            d="M1358.88 1409.13h-225.59c0-73.78 50.5-133.58 112.79-133.58s112.8 59.8 112.8 133.58Z"
          />
          <path
            className="cls5-1"
            d="M1133.29 1409.13a518.48 518.48 0 0 0 16.42 114.09l116.11 3.7c1.8-16.83 7.87-47.88 31.51-73 6.11-6.5 19.57-15.45 30.2-23.23 12.74-9.32 23.5-16.66 30.87-21.58Z"
          />
          <path
            className="cls5-3"
            d="M1149.71 1523.18c7.71 29 27.35 85.19 79 131 110.82 98.38 263.8 55.53 275.63 52a314.31 314.31 0 0 1-101.59-31.1c-89.32-45.23-131.49-121.37-146.47-152.39Z"
          />
          <path
            className="cls5-2"
            d="m1358.4 1409.13 277.6 335.61-133.11-38a334.85 334.85 0 0 1-124.07-34.7c-89.52-45.3-133.07-119-148.79-149.27 3.73-13.1 22.7-74.62 81.36-101.66a135.32 135.32 0 0 1 47.01-11.98Z"
          />
          <ellipse
            className="cls5-1"
            cx={1190.69}
            cy={1347.67}
            rx={13.51}
            ry={13.66}
          />
          <path
            className="cls5-1"
            d="M1133.29 1409.13H1086l57.83-53.78a140.35 140.35 0 0 0-10.55 53.78ZM1337.01 1767.56h53.72v11.88h-53.72z"
          />
          <path
            className="cls5-1"
            transform="rotate(-13.65 607.04 1732.172)"
            d="M599.64 1686.52h14.3v90.16h-14.3z"
          />
          <path
            className="cls5-3"
            d="M640 1409.13h225.61c0-73.78-50.5-133.58-112.79-133.58S640 1335.35 640 1409.13Z"
          />
          <path
            className="cls5-2"
            d="M865.61 1409.13a518.48 518.48 0 0 1-16.42 114.09l-116.11 3.7c-1.8-16.83-7.87-47.88-31.51-73-6.11-6.5-19.57-15.45-30.2-23.23a876.223 876.223 0 0 0-30.87-21.58Z"
          />
          <path
            className="cls5-1"
            d="M849.19 1523.18c-7.71 29-27.35 85.19-79 131-110.83 98.38-263.8 55.53-275.63 52a314.31 314.31 0 0 0 101.59-31.1c89.32-45.23 131.49-121.37 146.47-152.39Z"
          />
          <path
            className="cls5-3"
            d="m640.74 1409.13-277.86 335.61 133.22-38A335.3 335.3 0 0 0 620.28 1672c89.6-45.3 133.19-119 148.92-149.27-3.73-13.1-22.72-74.62-81.42-101.66a135.67 135.67 0 0 0-47.04-11.94Z"
          />
          <ellipse
            className="cls5-1"
            cx={808.21}
            cy={1347.67}
            rx={13.51}
            ry={13.66}
          />
          <path
            className="cls5-1"
            d="M865.61 1409.13h47.28l-57.83-53.78a140.35 140.35 0 0 1 10.55 53.78Z"
          />
          <path
            className="cls5-1"
            transform="rotate(-180 635.035 1773.495)"
            d="M608.17 1767.56h53.72v11.88h-53.72z"
          />
          <path
            className="cls5-3"
            d="M1002.12 1283.31h-5.33l-1.92-1.17c-113.57-69.14-216.22-143.62-305.1-221.31-86.24-75.37-157.87-152.3-212.91-228.65C422 756.11 385 682.51 366.89 613.44c-18.64-71-16.9-135.55 5.18-191.81 18.21-46.42 53.51-94.88 96.82-132.95 51.51-45.28 112.59-75.22 176.63-86.59 61-10.82 126.39-5 189.06 17 59.42 20.73 116.23 55.84 164.87 101.7 48.64-45.86 105.5-81 164.87-101.73 62.67-21.93 128-27.79 189.06-17 64 11.37 125.12 41.31 176.63 86.59 43.31 38.07 78.61 86.53 96.82 133 22.08 56.26 23.82 120.79 5.18 191.81-18.14 69.07-55.14 142.67-110 218.74-55 76.35-126.67 153.28-212.91 228.65-88.88 77.69-191.53 152.15-305.1 221.31ZM706.3 212.8a331.3 331.3 0 0 0-58 5C516.06 241.32 420.13 343 387 427.47c-86.62 220.7 165.12 565.22 612.49 838.73 447.37-273.51 699.1-618 612.49-838.73-33.17-84.51-129.1-186.15-261.36-209.62-117.79-20.91-247 23.86-345.55 119.75l-5.62 5.4-5.58-5.43C911.26 257.25 807.16 212.8 706.3 212.8Z"
          />
          <path
            className="cls5-2"
            d="M1396.84 1071.82c11.74-8.47 33.41-14.37 52.94-6 17.42 7.45 29.76 24.8 33.7 46 21.13-4.48 41.88.28 55.43 13.53 15.18 14.85 18 37.13 14.68 51.21-8.76 36.91-70.65 62.63-154.16 61.12l-.1-.07c-33.33-76.56-33.24-143.61-2.49-165.79ZM1666.37 1035.11c8.73-4 23.62-5.18 35.32 2.72 10.44 7.06 16.31 19.94 16.21 34.3 14.36-.27 27.31 5.45 34.49 15.8 8 11.61 7.1 26.51 3.14 35.28-10.36 23-54 32-108.32 20.53l-.06-.06c-12.15-54.19-3.65-97.93 19.22-108.57ZM1621.8 1248c6.22-2.3 16.5-2.25 24.1 3.82 6.78 5.43 10.1 14.59 9.23 24.45 9.88.61 18.45 5.25 22.81 12.75 4.88 8.42 3.4 18.59.2 24.4-8.38 15.21-38.84 19-75.5 8.1-5.37-37.96 2.88-67.52 19.16-73.52ZM602.72 1071.82c-11.73-8.47-33.4-14.37-52.93-6-17.43 7.45-29.76 24.8-33.7 46-21.13-4.48-41.89.28-55.43 13.53-15.19 14.85-18 37.13-14.68 51.21 8.76 36.91 70.64 62.63 154.15 61.12l.11-.07c33.33-76.56 33.23-143.61 2.48-165.79ZM333.19 1035.11c-8.72-4-23.61-5.18-35.31 2.72-10.44 7.06-16.32 19.94-16.22 34.3-14.35-.27-27.31 5.45-34.49 15.8-8 11.61-7.09 26.51-3.14 35.28 10.36 23 54 32 108.33 20.53l.06-.06c12.13-54.19 3.64-97.93-19.23-108.57ZM377.76 1248c-6.22-2.3-16.5-2.25-24.09 3.82-6.78 5.43-10.1 14.59-9.24 24.45-9.87.61-18.45 5.25-22.8 12.75-4.88 8.42-3.41 18.59-.21 24.4 8.39 15.21 38.84 19 75.51 8.1 5.37-37.96-2.88-67.52-19.17-73.52Z"
          />
        </g>
        {children}
      </g>
    </svg>
  );
}
